import { useEffect } from 'react';
import { createContext } from 'react';
import { useState } from 'react';
import { useConfigsServices } from './utils';
import _ from 'lodash';
import { useAuthContext } from '../../hooks/useAuthContext';
import { useIdleTimer } from 'react-idle-timer';
import useUserStore from '../../redux/utils/storeUtils';

export const ConfigsContext = createContext({});

const ConfigsContextProvider = ({ children }) => {
	const [configs, setConfigs] = useState([]);
	const { selectedClerk } = useUserStore();
	const { token, logout } = useAuthContext();
	const [activeConfigs, setActiveConfigs] = useState([]);
	const { getConfigs, filterActiveConfigs } = useConfigsServices();
	const county = selectedClerk
		? `${selectedClerk?.countyCodeDescription} ${selectedClerk?.clerkTypeDescription}`
		: '';
	const timeout = !_.isEmpty(activeConfigs)
		? activeConfigs.filter((item) => item.name === 'User Session Timeout Limit (seconds)')[0]
				.value * 1000
		: // Session Timeout defaults to 30 min (1800000 ms)
		  1800000;

	const { start } = useIdleTimer({
		crossTab: true,
		syncTimers: 500,
		timeout,
		startOnMount: false,
		onIdle: () => {
			logout();
		}
	});

	useEffect(() => {
		if (token && !_.isEmpty(county)) {
			getConfigs(county)
				.then((res) => {
					setConfigs(res);
				})
				.catch((e) => {
					console.log(e);
				});
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [county, token]);

	useEffect(() => {
		if (!_.isEmpty(configs)) {
			setActiveConfigs(filterActiveConfigs(configs));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [configs]);

	useEffect(() => {
		if (token) {
			start();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [token]);

	return (
		<ConfigsContext.Provider value={{ configs, setConfigs, county, activeConfigs }}>
			{children}
		</ConfigsContext.Provider>
	);
};

export default ConfigsContextProvider;
